import {
  register,
  login,
  changePassword,
  createApiKey,
  deleteApiKey,
  getApiKeys,
  sendResetCode,
  verifyCode,
  getUserProfile,
  updateUserProfile,
} from '../../api/user'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { Cookies } from 'react-cookie'
import toast from 'react-hot-toast'

const cookie = new Cookies()
// const isDev = process.env.NODE_ENV === 'development'
const cookieConfig = (res) => {
  return {
    path: '/',
    expires: new Date(+res.expiresIn * 1000),
  }
}
const initialState = {
  loadingRegister: false,
  loadingLogin: false,
  loadingVerifyCode: false,
  loadingApiKey: false,
  loadingSendResetCode: false,
  loadingChangePassword: false,
  errorRegister: null,
  errorApiKey: null,
  errorSendResetCode: null,
  errorChangePassword: null,
  errorLogin: null,
  errorVerifyCode: null,
  dataRegister: null,
  dataLogin: null,
  apiKeys: [],
  verifyCodePhase: false,
  userProfileData: null,
  loadingUserProfile: false,
  errorUserProfile: null,
}

export const registerUserReq = createAsyncThunk('register', async (data, { rejectWithValue }) => {
  const { username, email, password } = data
  try {
    const res = await register(username, email, password)
    cookie.set('token', res.token, cookieConfig(res))
    localStorage.setItem('user_role', res.role)
    return res
  } catch (err) {
    toast.error(err.response.data.message)
    return rejectWithValue({ err: err.response.data })
  }
})
export const changePasswordReq = createAsyncThunk(
  'changePassword',
  async (data, { rejectWithValue }) => {
    const { oldPassword, newPassword } = data
    try {
      const res = await changePassword(oldPassword, newPassword)
      toast.success(res.message)
      return res
    } catch (err) {
      toast.error(err.response.data.message)
      return rejectWithValue({ err: err.response.data })
    }
  },
)
export const loginUserReq = createAsyncThunk('login', async (data, { rejectWithValue }) => {
  const { username, password } = data
  try {
    const res = await login(username, password)
    cookie.set('token', res.token, cookieConfig(res))
    localStorage.setItem('user_role', res.role)
    return res
  } catch (err) {
    toast.error(err.response.data.message)
    return rejectWithValue({ err: err.response.data })
  }
})
export const createApiKeyReq = createAsyncThunk(
  'createApiKey',
  async (data, { rejectWithValue }) => {
    const { title } = data
    try {
      const res = await createApiKey(title)
      return res
    } catch (err) {
      toast.error(err.response.data.message)
      return rejectWithValue({ err: err.response.data })
    }
  },
)
export const sendResetCodeReq = createAsyncThunk(
  'sendResetCode',
  async (data, { rejectWithValue }) => {
    const { email } = data
    try {
      const res = await sendResetCode(email)
      toast.success(res.message)
      return res
    } catch (err) {
      toast.error(err.response.data.message)
      return rejectWithValue({ err: err.response.data })
    }
  },
)
export const verifyCodeReq = createAsyncThunk('verifyCode', async (data, { rejectWithValue }) => {
  const { email, new_password, code } = data
  try {
    const res = await verifyCode(email, code, new_password)
    toast.success(res.message)
    return res
  } catch (err) {
    toast.error(err.response.data.message)
    return rejectWithValue({ err: err.response.data })
  }
})
export const deleteApiKeyReq = createAsyncThunk(
  'deleteApiKey',
  async (data, { rejectWithValue }) => {
    const { id } = data
    try {
      const res = await deleteApiKey(id)
      return res
    } catch (err) {
      toast.error(err.response.data.message)
      return rejectWithValue({ err: err.response.data })
    }
  },
)
export const getApiKeysReq = createAsyncThunk('getApiKeys', async (data, { rejectWithValue }) => {
  try {
    const res = await getApiKeys()
    return res
  } catch (err) {
    toast.error(err.response.data.message)
    return rejectWithValue({ err: err.response.data })
  }
})
export const getUserProfileReq = createAsyncThunk(
  'getUserProfile',
  async (data, { rejectWithValue }) => {
    try {
      const res = await getUserProfile()
      return res
    } catch (err) {
      toast.error(err.response.data.message)
      return rejectWithValue({ err: err.response.data })
    }
  },
)

export const updateUserProfileReq = createAsyncThunk(
  'updateProfile',
  async (data, { rejectWithValue }) => {
    const { firstname, lastname, phone, nationalId } = data
    try {
      const res = await updateUserProfile(firstname, lastname, phone, nationalId)
      return res
    } catch (err) {
      toast.error(err.response.data.message)
      return rejectWithValue({ err: err.response.data })
    }
  },
)

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    toggleResetCodeForm: (state, action) => {
      state.verifyCodePhase = action.payload
    },
    resetForgetPass: (state, action) => {
      state.verifyCodePhase = false
      state.loadingVerifyCode = false
      state.loadingSendResetCode = false
      state.errorSendResetCode = null
      state.errorVerifyCode = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(registerUserReq.pending, (state, action) => {
        state.loadingRegister = true
        state.errorRegister = null
      })
      .addCase(registerUserReq.fulfilled, (state, action) => {
        state.loadingRegister = false
      })
      .addCase(registerUserReq.rejected, (state, action) => {
        state.loadingRegister = false
        state.errorRegister = action.payload
      })
      .addCase(changePasswordReq.pending, (state, action) => {
        state.loadingChangePassword = true
        state.errorChangePassword = null
      })
      .addCase(changePasswordReq.fulfilled, (state, action) => {
        state.loadingChangePassword = false
      })
      .addCase(changePasswordReq.rejected, (state, action) => {
        state.loadingChangePassword = false
        state.errorChangePassword = action.payload
      })
      .addCase(loginUserReq.pending, (state, action) => {
        state.loadingLogin = true
        state.errorLogin = null
      })
      .addCase(loginUserReq.fulfilled, (state, action) => {
        state.loadingLogin = false
      })
      .addCase(loginUserReq.rejected, (state, action) => {
        state.loadingLogin = false
        state.errorLogin = action.payload
      })
      .addCase(verifyCodeReq.pending, (state, action) => {
        state.loadingVerifyCode = true
        state.errorVerifyCode = null
      })
      .addCase(verifyCodeReq.fulfilled, (state, action) => {
        state.loadingVerifyCode = false
      })
      .addCase(verifyCodeReq.rejected, (state, action) => {
        state.loadingVerifyCode = false
        state.errorVerifyCode = action.payload
      })
      .addCase(createApiKeyReq.pending, (state, action) => {
        state.loadingApiKey = true
        state.errorApiKey = null
      })
      .addCase(createApiKeyReq.fulfilled, (state, action) => {
        state.loadingApiKey = false
        state.apiKeys = [...state.apiKeys, { id: action.payload.id, title: action.payload.title }]
      })
      .addCase(createApiKeyReq.rejected, (state, action) => {
        state.loadingApiKey = false
        state.errorApiKey = action.payload
      })
      .addCase(deleteApiKeyReq.pending, (state, action) => {
        state.loadingApiKey = true
        state.errorApiKey = null
      })
      .addCase(deleteApiKeyReq.fulfilled, (state, action) => {
        state.loadingApiKey = false
        state.apiKeys = state.apiKeys.filter((obj) => obj.id !== action.payload.id)
      })
      .addCase(deleteApiKeyReq.rejected, (state, action) => {
        state.loadingApiKey = false
        state.errorApiKey = action.payload
      })
      .addCase(sendResetCodeReq.pending, (state, action) => {
        state.loadingSendResetCode = true
        state.errorSendResetCode = null
      })
      .addCase(sendResetCodeReq.fulfilled, (state, action) => {
        state.loadingSendResetCode = false
        state.verifyCodePhase = true
      })
      .addCase(sendResetCodeReq.rejected, (state, action) => {
        state.loadingSendResetCode = false
        state.errorSendResetCode = action.payload
      })
      .addCase(getApiKeysReq.pending, (state, action) => {
        state.loadingApiKey = true
        state.errorApiKey = null
      })
      .addCase(getApiKeysReq.fulfilled, (state, action) => {
        state.loadingApiKey = false
        state.apiKeys = action.payload
      })
      .addCase(getApiKeysReq.rejected, (state, action) => {
        state.loadingApiKey = false
        state.errorApiKey = action.payload
      })
      .addCase(getUserProfileReq.pending, (state, action) => {
        state.loadingUserProfile = true
        state.errorUserProfile = null
      })
      .addCase(getUserProfileReq.fulfilled, (state, action) => {
        state.loadingUserProfile = false
        state.userProfileData = action.payload
      })
      .addCase(getUserProfileReq.rejected, (state, action) => {
        state.loadingUserProfile = false
        state.errorUserProfile = action.payload
      })
      .addCase(updateUserProfileReq.pending, (state, action) => {
        state.loadingUserProfile = true
        state.errorUserProfile = null
      })
      .addCase(updateUserProfileReq.fulfilled, (state, action) => {
        state.loadingUserProfile = false
        state.userProfileData = action.payload
      })
      .addCase(updateUserProfileReq.rejected, (state, action) => {
        state.loadingUserProfile = false
        state.errorUserProfile = action.payload
      })
  },
})

export const { toggleResetCodeForm, resetForgetPass } = userSlice.actions

export default userSlice.reducer
